import React, {Component} from 'react';
import ErrorMessage from '../Errors/ErrorMessage';
import errorTimeout from '../../assets/images/errors/timeout.svg';
import errorCard from '../../assets/images/errors/credit_card_fail.svg';
import PropTypes from 'prop-types';

class ErrorTimeoutView extends Component {

  constructor(props) {
    super(props);
    this.errorTimeout = errorTimeout;
    this.errorPayment = errorCard;
    this.state = {
      icon: this.errorTimeout,
    };
  }

  componentDidMount() {
    if (this.props.errorPayment) {
      this.setState({
        icon: this.errorPayment,
      });
    }
  }

  render() {
    const {icon} = this.state;
    const {onRetry, onReturn, inProgress} = this.props;
    return (
      <div className="error-wrapper">
        <ErrorMessage
          onRetry={onRetry}
          onReturn={onReturn}
          icon={icon}
          inProgress={inProgress}
        />
      </div>
    );
  }
}

ErrorTimeoutView.propTypes = {
  errorPayment: PropTypes.bool,
  inProgress: PropTypes.bool,
  onReturn: PropTypes.func,
  onRetry: PropTypes.func,
};

export default ErrorTimeoutView;



// WEBPACK FOOTER //
// ./src/components/App/ErrorTimeoutView.js